import { Link } from 'react-router-dom';
import { GameCard } from '../components/GameCard';
import { Hammer, Home, Calculator } from 'lucide-react';

const hausUndBauContent = [
  {
    title: 'Neubau oder Sanierung?',
    description: 'Die große Frage für viele Bauherren: Lieber neu bauen oder das Bestehende sanieren?',
    image: 'https://images.pexels.com/photos/5691521/pexels-photo-5691521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    path: '/tippspiele/neubau-oder-sanierung',
    type: 'decision',
    featured: true
  },
  {
    title: 'Was kostet eine Sanierung?',
    description: 'Schätze die Kosten typischer Sanierungsprojekte und plane realistisch.',
    image: 'https://images.unsplash.com/photo-1489515229412-1f3a8f08dc34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxob21lJTIwcmVub3ZhdGlvbiUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnMlMjBtb2Rlcm58ZW58MHx8fHwxNzc0MjU3ODc5fDA&ixlib=rb-4.1.0&q=85',
    path: '/haus-und-bau/was-kostet-eine-sanierung',
    type: 'estimation'
  },
  {
    title: 'Baufirma in Meran finden',
    description: 'Worauf du bei der Wahl deiner Baufirma achten solltest – ein Leitfaden.',
    image: 'https://images.unsplash.com/photo-1768464395439-25b2ef151f80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwZG9sb21pdGVzJTIwbW91bnRhaW4lMjB2aWxsYWdlJTIwc2NlbmljfGVufDB8fHx8MTc3NDI1Nzg4MHww&ixlib=rb-4.1.0&q=85',
    path: '/haus-und-bau/baufirma-meran',
    type: 'advisor'
  }
];

export default function HausUndBau() {
  return (
    <div className="section-spacing" data-testid="haus-bau-page">
      <div className="container-wide">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <nav className="text-sm text-[#64748B] mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Start</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0F172A]">Haus & Bau</span>
          </nav>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Haus & Bau
          </h1>
          <p className="text-lg text-[#475569]">
            Entscheidungshilfen und Ratgeber für alle, die bauen, sanieren oder 
            renovieren wollen. Mit Fokus auf Südtirol.
          </p>
        </div>

        {/* Quick Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            {
              icon: Home,
              title: 'Neubau planen',
              text: 'Von der Grundstückssuche bis zum Einzug – worauf es ankommt.'
            },
            {
              icon: Hammer,
              title: 'Sanierung durchführen',
              text: 'Bestandsimmobilien aufwerten und modernisieren.'
            },
            {
              icon: Calculator,
              title: 'Kosten kalkulieren',
              text: 'Realistische Budgets für dein Bauprojekt erstellen.'
            }
          ].map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="bg-white rounded-xl p-6 border border-[#E2E8F0]">
                <div className="w-10 h-10 rounded-lg bg-[#059669]/10 flex items-center justify-center mb-4">
                  <Icon className="text-[#059669]" size={20} />
                </div>
                <h3 className="font-semibold text-[#0F172A] mb-2">{item.title}</h3>
                <p className="text-sm text-[#475569]">{item.text}</p>
              </div>
            );
          })}
        </div>

        {/* Games Grid */}
        <h2 className="text-2xl font-bold text-[#0F172A] mb-6 font-[var(--font-heading)]">
          Interaktive Inhalte
        </h2>
        <div className="bento-grid mb-12">
          {hausUndBauContent.map((game, index) => (
            <GameCard key={index} {...game} />
          ))}
        </div>

        {/* Ratgeber Link */}
        <div className="bg-[#059669]/5 border border-[#059669]/20 rounded-xl p-8">
          <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Ausführlicher Ratgeber
          </h2>
          <p className="text-[#475569] mb-6">
            Du planst ein größeres Bauprojekt in Südtirol? Unser ausführlicher 
            Ratgeber erklärt alles Wichtige: von den Bauvorschriften über die 
            Grundstückssuche bis zur Wahl der richtigen Baufirma.
          </p>
          <Link 
            to="/ratgeber/hausbau-in-suedtirol"
            className="inline-flex items-center gap-2 text-[#059669] font-medium hover:underline"
          >
            Zum Ratgeber: Hausbau in Südtirol →
          </Link>
        </div>
      </div>
    </div>
  );
}
